import React from 'react';
import { Link } from 'react-router-dom';
import useHomePath from 'hooks/useHomePath';
import { env } from 'constants';
import useIsDesktop from 'hooks/useIsDesktop';
import { Typography } from '@mui/material';
import useMerchant from 'hooks/useMerchant';

function Logo() {
  const homePath = useHomePath();
  const isDesktop = useIsDesktop();
  const { merchant } = useMerchant();

  return (
    <Link to={homePath} style={{ height: isDesktop ? 32 : 24 }}>
      {!env.IS_MARKETPLACE ? (
        <Typography
          variant="title-h6"
          component="h1"
          color="text.primary"
          sx={!isDesktop && {
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            display: '-webkit-box',
            WebkitLineClamp: '2',
            WebkitBoxOrient: 'vertical',
          }}
        >
          {merchant?.name}
        </Typography>
      ) : (
        <img
          src="/logo.png"
          alt="Logo"
          style={{
            height: '100%',
            maxWidth: env.IS_CATERING ? 'unset' : 85,
            objectFit: 'contain',
          }}
        />
      )}
    </Link>
  );
}
export default Logo;
